import { Injectable } from "@angular/core";
import { map } from "rxjs";
import { HttpService } from "../common/http-service";
import { environment } from 'src/environments/environment';
import { SearchGeneralManagerModel } from "../../models/system-profiles/search-general-manager.model";
import { DeleteAdministratorModel } from "../../models/system-profiles/delete-administrator.model";
import { SearchTechSupportModel } from "../../models/system-profiles/search-tech-support.model";
import { HttpClient, HttpHeaders, HttpRequest } from "@angular/common/http";
import { UserProfileModel } from "../../models/system-profiles/user-profile.model";
import { DatePipe } from "@angular/common";
import { TechSupportModel } from "../../models/system-profiles/tech-support.model";
import { SearchSuperAdministratorModel } from "../../models/system-profiles/search-super-administrator.model";
import { SuperAdministratorModel } from "../../models/system-profiles/super-administrator.model";
import { DeleteSuperAdministratorModel } from "../../models/system-profiles/delete-super-administrator.model";

const SADM_API = environment.apiURL + '/api/adm/SuperAdmin/'
const GMNG_API = environment.apiURL + '/api/adm/GeneralManager/'
const TECH_API = environment.apiURL + '/api/adm/Techsupport/'
const USER_API = environment.apiURL + '/api/adm/User/';
const COMPANY_API = environment.apiURL + '/api/adm/Company/';
@Injectable({
    providedIn: 'root'
})
export class AdministratorService {
    //#region Fields
    //#endregion

    //#region Constructor

    constructor(private _httpService: HttpService, private _httpClient: HttpClient) {
    }
    //#endregion

    //#region Public Methods
    getuserprofile() {
        var url = USER_API + "getuserprofile";
        return this._httpService.httpGet(url)
            .pipe(map(resposne => {
                return resposne;
            }));
    }
    updateuserprofile(model: UserProfileModel, file: any) {
        var url = USER_API + "updateuserprofile";
        const formData: FormData = new FormData();
        formData.append('FirstName', model.firstName as string)
        formData.append('LastName', model.lastName as string)
        formData.append('Phone', model.phone as string)
        const datepipe: DatePipe = new DatePipe('en-US')
        let formattedDate = datepipe.transform(model.dateOfBirth, 'MM/dd/yyyy')
        formData.append('DateOfBirth', formattedDate as string)
        formData.append('profileImage', file as string)
        return this._httpClient
            .post<any>(url, formData)
            .pipe(map(resposne => {
                return resposne;
            }));
    }
    getAllAdmins(model: SearchGeneralManagerModel) {
        var url = GMNG_API + "getalladmins";
        return this._httpService.httpPost(url, model)
            .pipe(map(resposne => {
                return resposne;
            }));
    }
    addAdmin(model: UserProfileModel, file: any) {
        var url = GMNG_API + "addadmin";
        const formData: FormData = new FormData();
        formData.append('Email', model.email as string)
        formData.append('FirstName', model.firstName as string)
        formData.append('LastName', model.lastName as string)
        formData.append('Phone', model.phone as string)
        const datepipe: DatePipe = new DatePipe('en-US')
        let formattedDate = datepipe.transform(model.dateOfBirth, 'MM/dd/yyyy')
        formData.append('DateOfBirth', formattedDate as string)
        formData.append('CompanyId', model.companyId as string)
        formData.append('LanguageId', localStorage.getItem('languageId') as string)
        formData.append('profileImage', file as string)
        return this._httpClient
            .post<any>(url, formData)
            .pipe(map(resposne => {
                return resposne;
            }));
    }
    updateAdmin(model: UserProfileModel, file: any) {
        var url = GMNG_API + "updateadmin";
        const formData: FormData = new FormData();
        formData.append('AdminId',model.adminId as string)
        formData.append('Email', model.email as string)
        formData.append('FirstName', model.firstName as string)
        formData.append('LastName', model.lastName as string)
        formData.append('Phone', model.phone as string)
        const datepipe: DatePipe = new DatePipe('en-US')
        let formattedDate = datepipe.transform(model.dateOfBirth, 'MM/dd/yyyy')
        formData.append('DateOfBirth', formattedDate as string)
         formData.append('CompanyId', model.companyId as string)
        formData.append('LanguageId', localStorage.getItem('languageId') as string)
        formData.append('profileImage', file as string)
        return this._httpClient
            .post<any>(url, formData)
            .pipe(map(resposne => {
                return resposne;
            }));
    }
    deleteAdmin(model: DeleteAdministratorModel) {
        var url = GMNG_API + "deleteadmin";
        return this._httpService.httpPost(url, model)
            .pipe(map(resposne => {
                return resposne;
            }));
    }
    getadminbyid(id: string) {
        var url = GMNG_API + 'getadmin?adminId=' + id;
        return this._httpService.httpGet(url)
            .pipe(map(resposne => {
                return resposne;
            }));
    }
    getAllTechSupport(model: SearchTechSupportModel) {//change with techSupport API calls
        var url = TECH_API + "getalltechsupports";
        return this._httpService.httpPost(url, model)
            .pipe(map(resposne => {
                return resposne;
            }));
    }
    getTechSupportById(id: string) {
        var url = TECH_API + 'gettechsupport?id=' + id;
        return this._httpService.httpGet(url)
            .pipe(map(resposne => {
                return resposne;
            }));
    }
    addTechSupport(model: TechSupportModel, file: any) {
        var url = TECH_API + "addtechsupport";
        const formData: FormData = new FormData();
        formData.append('Email', model.email as string)
        formData.append('FirstName', model.firstName as string)
        formData.append('LastName', model.lastName as string)
        formData.append('Phone', model.phone as string)
        const datepipe: DatePipe = new DatePipe('en-US')
        let formattedDate = datepipe.transform(model.dateOfBirth, 'MM/dd/yyyy')
        formData.append('DateOfBirth', formattedDate as string)       
        formData.append('LanguageId', localStorage.getItem('languageId') as string)
        formData.append('profileImage', file as string)
        if(model.assignedCompanies != undefined){
            for(let i = 0; i < model.assignedCompanies.length; i++) {
              formData.append("AssignedCompanies", model.assignedCompanies[i])
            }
          }
        return this._httpClient
            .post<any>(url, formData)
            .pipe(map(resposne => {
                return resposne;
            }));
    }
    updateTechSupport(model: TechSupportModel, file: any) {
        var url = TECH_API + "updatetechsupport";
        const formData: FormData = new FormData();
        formData.append('TechsupportId',model.id as string)
        formData.append('Email', model.email as string)
        formData.append('FirstName', model.firstName as string)
        formData.append('LastName', model.lastName as string)
        formData.append('Phone', model.phone as string)
        const datepipe: DatePipe = new DatePipe('en-US')
        let formattedDate = datepipe.transform(model.dateOfBirth, 'MM/dd/yyyy')
        formData.append('DateOfBirth', formattedDate as string)       
        formData.append('LanguageId', localStorage.getItem('languageId') as string)
        formData.append('profileImage', file as string)
        if(model.assignedCompanies != undefined){
            for(let i = 0; i < model.assignedCompanies.length; i++) {
              formData.append("AssignedCompanies", model.assignedCompanies[i])
            }
          }
        return this._httpClient
            .post<any>(url, formData)
            .pipe(map(resposne => {
                return resposne;
            }));
    }
    deleteTechSupport(model: DeleteAdministratorModel) {
        var url = TECH_API + "deletetechsupport";
        return this._httpService.httpPost(url, model)
            .pipe(map(resposne => {
                return resposne;
            }));
    }
    getAllCompanyNames() {
        var url = COMPANY_API + "getallcompanynames";
        return this._httpService.httpGet(url)
            .pipe(map(resposne => {
                return resposne;
            }));
    }
    getAllSuperAdmins(model: SearchSuperAdministratorModel) {
        var url = SADM_API + "getallsuperadmins";
        return this._httpService.httpPost(url, model)
            .pipe(map(resposne => {
                return resposne;
            }));
    }
    getsuperadminbyid(id: string) {
        var url = SADM_API + 'getsuperadmin?id=' + id;
        return this._httpService.httpGet(url)
            .pipe(map(resposne => {
                return resposne;
            }));
    }
    updatesuperadmin(model: SuperAdministratorModel, file: any) {
        var url = SADM_API + "updatesuperadmin";
        const formData: FormData = new FormData();
        formData.append('AdminId',model.id as string)
        formData.append('Email', model.email as string)
        formData.append('FirstName', model.firstName as string)
        formData.append('LastName', model.lastName as string)
        formData.append('Phone', model.phone as string)
        const datepipe: DatePipe = new DatePipe('en-US')
        let formattedDate = datepipe.transform(model.dateOfBirth, 'MM/dd/yyyy')
        formData.append('DateOfBirth', formattedDate as string)       
        formData.append('LanguageId', localStorage.getItem('languageId') as string)
        formData.append('profileImage', file as string)
        return this._httpClient
            .post<any>(url, formData)
            .pipe(map(resposne => {
                return resposne;
            }));
    }
    addsuperadmin(model: SuperAdministratorModel, file: any) {
        var url = SADM_API + "addsuperadmin";
        const formData: FormData = new FormData();
        formData.append('Email', model.email as string)
        formData.append('FirstName', model.firstName as string)
        formData.append('LastName', model.lastName as string)
        formData.append('Phone', model.phone as string)
        const datepipe: DatePipe = new DatePipe('en-US')
        let formattedDate = datepipe.transform(model.dateOfBirth, 'MM/dd/yyyy')
        formData.append('DateOfBirth', formattedDate as string)       
        formData.append('LanguageId', localStorage.getItem('languageId') as string)
        formData.append('profileImage', file as string)
        return this._httpClient
            .post<any>(url, formData)
            .pipe(map(resposne => {
                return resposne;
            }));
    }
    deletesuperadmin(model: DeleteSuperAdministratorModel) {
        var url = SADM_API + "deletesuperadmin";
        return this._httpService.httpPost(url, model)
            .pipe(map(resposne => {
                return resposne;
            }));
    }
    //#endregion
}